import { useTranslation } from "react-i18next";
import styles from "./app-title.module.scss";
import ProphiaPLogo from "@/assets/prophia/prophia-p-logo.svg";
import { useNavigate } from "react-router-dom";
import { HOME_ROUTE, LOGIN_ROUTE } from "@/routing/app-routes";
import useWorkspaceId from "@/hooks/use-workspace-id/useWorkspaceId";
import composeRoute from "@/api/routes/utils/route-utils/route-utils";

const AppTitle = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { workspaceId } = useWorkspaceId();
  const route = workspaceId
    ? composeRoute(HOME_ROUTE, [workspaceId])
    : LOGIN_ROUTE;

  return (
    <div className={styles.appTitle}>
      <div className="p-4 flex align-center">
        <img
          src={ProphiaPLogo}
          alt="Prophia P Logo"
          className={styles.logo}
          onClick={() => navigate(route)}
        />
        <div
          className={`${styles.text} ${styles.logo} ml-2 bold`}
          onClick={() => navigate(route)}
        >
          {t("prophiaAbstract")}
        </div>
      </div>
    </div>
  );
};

export default AppTitle;
